import React, { memo } from 'react'
import { Button, Grid, Typography } from '@material-ui/core'
import { Form, Formik } from 'formik'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'

import { MODIFICAR_LLENADO_SCHEMA } from '../../constants'
import { NuevaEtiquetasSelect } from '../../nuevaEtiquetasSelect/NuevaEtiquetasSelect'

export const OperacionModificarInicioDeLlenadoView = memo(({ silo, cancelar, aceptar }) => (
  <Formik
    initialValues={{
      etiqueta: silo.etiqueta || '',
      color: silo.color || ''
    }}
    onSubmit={aceptar}
    validationSchema={MODIFICAR_LLENADO_SCHEMA}
  >
    {({ isSubmitting, isValid }) => (
      <Form>
        <Grid container spacing={2} direction='column' justify='space-around'>
          <Grid item>
            <Typography variant='h6'>Modificar Inicio de llenado de {silo.nombreCorto}</Typography>
          </Grid>
          <Grid item>
            <NuevaEtiquetasSelect silo={silo} />
          </Grid>
          <Grid container item spacing={2} justify='space-between'>
            <Grid item xs='auto'>
              <Button
                variant='contained'
                color='secondary'
                disabled={isSubmitting}
                startIcon={<HighlightOffIcon />}
                onClick={cancelar}>
                Cancelar
              </Button>
            </Grid>
            <Grid item xs='auto'>
              <Button
                variant='contained'
                color='primary'
                disabled={isSubmitting || !isValid}
                startIcon={<CheckCircleOutlineIcon />}
                type='submit'>
                Aceptar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Form>
    )}
  </Formik>
))
